import { render, staticRenderFns } from "./caipan.vue?vue&type=template&id=19c8e59f"
import script from "./caipan.vue?vue&type=script&lang=ts"
export * from "./caipan.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports